<template>
	<div class="notes-list__item">
		<div style="flex-grow: 1">
			<div
				class="d-flex align-center justify-space-between"
				style="width: 100%; min-width: 0"
			>
				<div
					@click="selectUser"
					class="d-flex align-center cursor-pointer"
					style="flex-grow: 1; min-width: 0"
				>
					<Avatar
						borderRadius="square"
						class="notes-list__item-avatar mr-3"
						:size="40"
						:avatar="resourceItem.follow.user_logo"
					/>
					<div class="notes-list__item__username-wrapper">
						<div class="notes-list__item-username pa-0">
							{{ resourceItem.follow.visible_username }}
						</div>
						<div class="notes-list__item-second-row pa-0">
							{{ resourceItem.follow.second_profile_row }}
						</div>
					</div>
				</div>
				<div class="notes-list__item-date pa-0 ma-0">
					{{ dateCreated(resourceItem.note_updated) }}
				</div>
			</div>
			<p
				@click="selectNote"
				v-html="resourceItem.follow_note"
				class="notes-list__item-text"
			/>
		</div>
	</div>
</template>

<script>
import Avatar from '../Avatar'
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'

export default {
	name: 'NoteItem',
	components: {
		Avatar,
	},
	data() {
		return {
			fileColors: [
				{ color: '#50bee8', ext: ['jpg', 'jpeg', 'psd'] },
				{ color: '#6678aa', ext: ['bmp'] },
				{ color: '#a066aa', ext: ['png', 'gif'] },
				{ color: '#f15642', ext: ['pdf'] },
				{ color: '#50bee8', ext: ['doc', 'docx'] },
				{ color: '#638674', ext: ['rtf'] },
				{ color: '#f15642', ext: ['ppt'] },
				{ color: '#84bd5a', ext: ['xls', 'xlsx'] },
				{ color: '#f7b84e', ext: ['mp3', 'wav', 'flac'] },
				{ color: '#f7b84e', ext: ['avi', 'mp4', 'mpeg'] },
				{ color: '#576d7e', ext: ['txt'] },
				{ color: '#e59f2b', ext: ['zip', 'rar', '7z', 'gz', 'gzip', 'bzip'] },
				{ color: '#41a8e1', ext: ['url'] },
			],
		}
	},
	props: {
		resourceItem: {
			type: Object,
			default: () => ({}),
		},
	},
	computed: {
		...mapGetters('resources', ['resourcesList', 'isLoading', 'listMeta', 'breadCrumbs']),
	},
	methods: {
		...mapActions('resources', ['breadCrumbHandler']),
		...mapActions('profile', ['updateEditableNote']),

		folderClickHandler(resourceItem = {}) {
			const { resource_id: id, resources_name: name } = resourceItem

			this.breadCrumbHandler([{ id, name }])
		},
		formateBreadCrumbs(resourceId) {
			const listIds = this.breadCrumbs.map((item) => item.id)

			if (_.isEmpty(listIds)) {
				return {}
			}

			return {
				bread_crumbs: [...listIds, +resourceId].join(','),
			}
		},
		fileIconColor(file) {
			if (!file.filename) return '#8b8b8b'

			const extName = this.fileIconName(file)
			const colorDataObj = extName && this.fileColors.find((i) => i.ext.indexOf(extName) > -1)

			return colorDataObj ? colorDataObj.color : '#8b8b8b'
		},
		dateCreated(originalDate) {
			const date = new Date(originalDate * 1000)
			const options = {
				month: 'short',
				day: 'numeric',
				hour: 'numeric',
				minute: 'numeric',
				hour12: true,
			}

			return new Intl.DateTimeFormat('en-US', options).format(date)
		},
		fileIconName(file) {
			if (file.metadata) {
				return (file.filename || '').split('.').pop().substring(0, 4)
			}

			return 'url'
		},
		selectNote() {
			this.updateEditableNote(this.resourceItem)
			this.$router.push({
				name: 'profile-note-by-id',
				params: { id: this.resourceItem.follow_id },
			})
		},
		selectUser() {
			this.$router.push({ name: 'user-by-id', params: { id: this.resourceItem.follow_id } })
		},
	},
	created() {
		//
	},
}
</script>

<style lang="scss">
.notes-list__item {
	width: 100%;
	display: flex;
	justify-content: space-between;
	flex-wrap: nowrap;
	padding: 12px !important;
	margin-bottom: 8px;
	border-radius: 8px;
	background: #ffffff;
	border: 1px solid #e2e2e2;
	font-family: 'Inter', sans-serif;
	&__username-wrapper {
		flex-grow: 1;
		min-width: 0;
		height: 46px;

		.notes-list__item-username {
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			display: block;
		}
	}
	&-second-row {
		font-family: 'Inter', sans-serif;
		font-weight: 400;
		font-size: 15px;
		line-height: 20px;
		letter-spacing: 0;
		color: #4a4a4a;
	}

	&-username {
		font-size: 18px;
		font-weight: 700;
		line-height: 21.94px;
		color: var(--accent-color);
		margin-bottom: 6px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		display: block;
	}

	&-date {
		width: 98px;
		height: 46px;
		white-space: nowrap;
		display: flex;
		align-items: flex-end;
		font-family: 'Inter', sans-serif;
		font-weight: 400;
		font-size: 13px;
		line-height: 100%;
		letter-spacing: 0;
		text-align: right;
		color: #9b9b9b;
	}

	&-text {
		font-family: 'Inter', sans-serif;
		font-weight: 400;
		font-size: 16px;
		line-height: 100%;
		letter-spacing: 0;
		color: #4a4a4a;
		margin: 16px 0 0 !important;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		word-break: break-word;
		cursor: pointer;
	}
}
</style>
